import { motion } from "framer-motion";
import { EASE } from "@/lib/site";

export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div", ...rest }) => {
  const Tag = motion[as];
  return (
    <Tag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, ease: EASE, delay }}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export const MaskedLines = ({ lines, className = "", delay = 0.15, as = "h1", lineClass = "", inView = false, testid }) => {
  const Tag = motion[as];
  const trigger = inView ? { whileInView: "show", viewport: { once: true, amount: 0.1 } } : { animate: "show" };
  return (
    <Tag className={className} data-testid={testid} initial="hidden" {...trigger}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.12em] -mb-[0.12em]">
          <motion.span
            className={`block ${lineClass}`}
            variants={{ hidden: { y: "110%" }, show: { y: "0%" } }}
            transition={{ duration: 1.15, ease: EASE, delay: delay + i * 0.11 }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

export const FadeIn = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 18 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 1, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);
